import { AbstractControl } from "@angular/forms";

/**
 * Url Pattern
 */
const urlPattern =
  "^" +
  // protocol identifier
  "(?:(?:https?|ftp)://)" +
  // user:pass authentication
  "(?:\\S+(?::\\S*)?@)?" +
  "(?:" +
  // IP address exclusion
  // private & local networks
  "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
  "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
  "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
  // IP address dotted notation octets
  // excludes loopback network 0.0.0.0
  // excludes reserved space >= 224.0.0.0
  // excludes network & broacast addresses
  // (first & last IP address of each class)
  "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
  "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
  "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
  "|" +
  // host name
  "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
  // domain name
  "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
  // TLD identifier
  "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
  // TLD may end with dot
  "\\.?" +
  ")" +
  // port number
  "(?::\\d{2,5})?" +
  // resource path
  "(?:[/?#]\\S*)?" +
  "$";
/**
 * Url Validator
 */
export const UrlValidator = (control: AbstractControl) => {
  let pattern = new RegExp(urlPattern, "i");

  if (control.value === null || control.value.trim() == "") {
    return null;
  }

  return pattern.test(control.value) ? null : { noValidUrl: true };
};

/**
 * Email Validator
 */
export const EmailValidator = (control: AbstractControl) => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (control.value == "") {
    return null;
  }

  return pattern.test(control.value) ? null : { noValidEmail: true };
};

export const ColorValidator = (control: AbstractControl) => {
  let colorPattern = "^#(?:[0-9a-fA-F]{3}){1,2}$";

  let pattern = new RegExp(colorPattern, "i");

  if (control.value === null || control.value.trim() === "") {
    return null;
  }

  return pattern.test(control.value) ? null : { noValidColor: true };
};



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/validators.ts